// Google Ads conversion tracking (client-side gtag).
//
// The Google Ads base tag (AW-18257089254) is loaded in public/index.html,
// which defines the global `gtag` function. Call trackConversion('<key>')
// at the moment the action succeeds. To add a new conversion, register its
// send_to value here — nothing else needs to change.

const CONVERSIONS = {
  registered:        'AW-18257089254/LAMvCMnSwckcEOal1IFE', // Google Ads label: "Enrollment Complete"
  evaluation_booked: 'AW-18257089254/GbrCCMbSwckcEOal1IFE',
  payment_started:   'AW-18257089254/b7ljCMzSwckcEOal1IFE',
};

/**
 * Fire a Google Ads conversion.
 * @param {string} key            A key from CONVERSIONS above.
 * @param {object} options
 * @param {string} [options.email] User email for Enhanced Conversions. gtag
 *                                 SHA-256-hashes it in-browser before sending;
 *                                 requires Enhanced Conversions enabled in the
 *                                 Google Ads account (else it's ignored).
 * @param {object} [options...]    Extra gtag params (e.g. transaction_id, value, currency).
 */
export function trackConversion(key, { email, ...params } = {}) {
  const sendTo = CONVERSIONS[key];
  if (!sendTo) {
    console.warn(`[google-ads] unknown conversion key: ${key}`);
    return;
  }
  if (typeof window.gtag !== 'function') {
    console.warn('[google-ads] gtag not loaded — conversion not sent:', key);
    return;
  }
  if (email) {
    // Enhanced Conversions: provide user-provided data; gtag normalizes + hashes it.
    window.gtag('set', 'user_data', { email });
  }
  window.gtag('event', 'conversion', { send_to: sendTo, ...params });
}
